import React from "react";
// import { DownOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Space } from "antd";

const initParams = {
  deviceNo: "",
  remark: "",
};

export default function SearchHead(props) {
  const [form] = Form.useForm();
  // 搜索
  const onFinish = (values) => {
    const { deviceNo = "", remark = "" } = values;
    props.handleSearch({
      ...initParams,
      deviceNo,
      remark,
    });
  };

  // 重置
  const reset = () => {
    form.resetFields();
    props.handleSearch({
      ...initParams,
    });
    props.handleReset({
      ...initParams,
    });
  };

  return (
    <>
      <div className="search">
        <Form
          form={form}
          name="advanced_search"
          onFinish={onFinish}
          labelCol={{
            flex: "130px",
          }}
          labelAlign="right"
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="deviceNo" label="设备号">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="remark" label="备注">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <Space size="small">
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
              <Button onClick={reset}>重置</Button>
            </Space>
          </div>
        </Form>
      </div>
      <div className="line"></div>
    </>
  );
}
